module.exports = __webpack_public_path__ + "img/xy.bee1fe52.gif";